'use client';

import { Tabs, TabsList, TabsTrigger } from '#/components/ui/tabs';
import { MenuItem } from '#/data/menu';
import { ReactNode } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { trackEvent } from '#/lib/analytics';

interface NavTabProps {
  items: MenuItem[];
  actions?: ReactNode;
  fontSize?: string;
}

export default function NavTab({ items = [], actions, fontSize }: NavTabProps) {
  const router = useRouter();
  const pathname = usePathname();

  // 현재 경로와 일치하는 탭이 없으면 첫 번째 탭으로 폴백(SSR/CSR 안정화)
  const active =
    items.find((v) => v.href === pathname)?.href ??
    items.find((v) => v.active)?.href ??
    items[0]?.href ??
    '';

  return (
    <div className="flex items-center justify-between">
      <Tabs
        value={active}
        onValueChange={(v) => {
          if (v && v !== pathname) {
            // GA4: 한 기능만 쓰고 이탈했는지, 다른 도구로 넘어갔는지 보는 지표.
            trackEvent('click_other_menu', {
              location: 'try_tab',
              from: pathname ?? '',
              to: v
            });
            router.push(v);
          }
        }}
        className="space-y-4 w-full sm:w-auto"
      >
        <TabsList className="flex flex-wrap h-auto gap-1 w-full sm:w-fit">
          {items.map((item) => (
            <TabsTrigger
              key={item.href}
              value={item.href}
              className={`${fontSize} cursor-pointer text-xs sm:text-sm px-2 sm:px-3`}
            >
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      {actions}
    </div>
  );
}
